import { Logger } from "@client/helpers/Logger";
import {
    EmptyQueryItemsResult,
    PlainObject,
    QueryItemsArgs,
    QueryItemsResult,
    QueryRequestOptions
} from "@core/models";

export async function exec<TResult>(
    command: "QueryDatasource",
    args: QueryItemsArgs & { name: string; },
    options: QueryRequestOptions
): Promise<TResult>;

export async function exec<TResult extends QueryItemsResult>(
    command: "QueryEntityObjects",
    args: QueryItemsArgs & { entity: string; },
    options: QueryRequestOptions
): Promise<TResult>;

export async function exec<TResult = any>(
    command: string,
    args: PlainObject = {},
    options: QueryRequestOptions
): Promise<TResult> {
    // Placeholder implementation
    if (command === "QueryEntityObjects") {
        const response = await fetch("/apis/query-entity-items", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${options.accessToken}`,
            },
            body: JSON.stringify(args),
        }).then(res => res.json());
        const result = QueryItemsResult.tryParse(response, error => {
            Logger.error("Failed to parse QueryEntityObjects result!", error);
        }) || EmptyQueryItemsResult;
        return result as TResult;
    } else if (command === "QueryDatasource") {
        const { name, ...rest } = args;
        const result = await fetch(`/apis/datasources/${name}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${options.accessToken}`,
            },
            body: JSON.stringify(rest),
        }).then(res => res.json());
        return result as TResult;
    }
    throw new Error(`Unknown command: ${command}`);
}